import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './seasons.jade'
import {Season} from '../../models'
import '@scoutgg/ftw/source/atoms/dropdown/dropdown'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('blank', String)
@Attribute('sport', String)
export default class Seasons extends HTMLElement {
  attached() {
    this.byLeague = {}
    this.seasonsLoad()
  }

  seasonsLoad() {
    Season.load({active: true}).then((data) => {
      if(this.sport) {
        this.seasons = data.seasons.filter((season) => season.sport === this.sport)
      } else {
        this.seasons = data.seasons
      }
    }).then(() => {
      this.seasons = this.seasons.sort((a, b) => {
        if(a.league.name !== b.league.name) {
          return (a.league.name || '').localeCompare(b.league.name || '')
        }
        if(a.league !== b.league) return a.leagueId.localeCompare(b.leagueId)
        if(a.season !== b.season) return b.season - a.season
        return b._id.localeCompare(a._id)
      })
      this.render()
    })
  }

  sportChange() {
    this.seasonsLoad()
    this.render()
  }

  changeSeason(season) {
    this.season = season || null
    this.render()
    this.emit('change:season', {season: this.season})
  }
}
